import mod from './index.js'

export default mod
export const Vec3 = mod.Vec3
